/**
 * @author        jose.lucena@zumper.com (José Lucena)
 * @copyright     Copyright (c) 2025, Zumper
 * @description   Metro rent report
 */

import camelcaseKeys from 'camelcase-keys'
import type {
  MetroRentReport as MetroRentReportType,
  RawMetroRentReport,
} from './metroRentReport.types'

export const MetroRentReport = {
  fromJS: (data: RawMetroRentReport): MetroRentReportType => camelcaseKeys(data, { deep: true }),
}

export type MetroRentReport = MetroRentReportType
